import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
    },
    {
        path: 'auth',
        loadChildren: () => import('src/app/auth/auth.module').then(m => m.AuthModule),
        data: {
            breadcrumb: 'Autenticação',
            navigableBreadcrumb: false
        }
    },
    {
        path: 'atos',
        loadChildren: () => import('src/app/atos/atos.module').then(m => m.AtosModule),
        data: {
            breadcrumb: 'Atos',
            navigableBreadcrumb: false
        }
    },
    {
        path: 'anotacoes',
        loadChildren: () => import('src/app/anotacoes/anotacoes.module').then(m => m.AnotacoesModule),
        data: {
            breadcrumb: 'Anotacoes',
            navigableBreadcrumb: false
        }
    },
    {
        path: 'consulta',
        loadChildren: () => import('src/app/consulta/consulta.module').then(m => m.ConsultaModule),
        data: {
            breadcrumb: 'Consulta',
            navigableBreadcrumb: false
        }
    },
    {
        path: 'ferramentas',
        loadChildren: () => import('src/app/ferramentas/ferramentas.module').then(m => m.FerramentasModule),
        data: {
            breadcrumb: 'Ferramentas',
            navigableBreadcrumb: false
        }
    },
    {
        path: 'luds',
        loadChildren: () => import('src/app/luds/luds.module').then(m => m.LudsModule),
        data: {
            breadcrumb: 'LUDs',
            navigableBreadcrumb: false
        }
    },
    {
        path: 'parametros',
        loadChildren: () => import('src/app/parametros/parametros.module').then(m => m.ParametrosModule),
        data: {
            breadcrumb: 'Parâmetros',
            navigableBreadcrumb: false
        }
    },
    {
        path: 'tipos-segmento',
        loadChildren: () => import('src/app/tipos-segmento/tipos-segmento.module').then(m => m.TiposSegmentoModule),
        data: {
            breadcrumb: 'Tipos de segmento',
            navigableBreadcrumb: false
        }
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { useHash: true })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
